var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightModeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_1852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99889 16.6944C9.62198 16.6944 9.31641 17 9.31641 17.3769V19.3173C9.31641 19.6943 9.62198 19.9998 9.99889 19.9998C10.3759 19.9998 10.6814 19.6943 10.6814 19.3173V17.3769C10.6814 16.9999 10.3758 16.6944 9.99889 16.6944Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99889 3.30585C10.3759 3.30585 10.6814 3.00028 10.6814 2.62337V0.682757C10.6814 0.305845 10.3759 0.000274658 9.99889 0.000274658C9.62198 0.000274658 9.31641 0.305845 9.31641 0.682757V2.62337C9.31641 3.00028 9.62198 3.30585 9.99889 3.30585Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3014 14.7333L2.9288 16.1052C2.66217 16.3716 2.66208 16.8038 2.92852 17.0703C3.06183 17.2036 3.23655 17.2703 3.41126 17.2703C3.58589 17.2703 3.76042 17.2037 3.89373 17.0706L5.26634 15.6987C5.53297 15.4323 5.53306 15.0001 5.26661 14.7336C4.99999 14.467 4.56794 14.467 4.3014 14.7333Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2156 5.46597C15.3903 5.46597 15.5649 5.39936 15.6982 5.26614L17.0706 3.89426C17.3371 3.62773 17.3372 3.19567 17.0708 2.92905C16.8043 2.66242 16.3722 2.66233 16.1056 2.92896L14.7332 4.30084C14.4666 4.56728 14.4665 4.99942 14.733 5.26596C14.8662 5.39936 15.0409 5.46597 15.2156 5.46597Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3054 10.0002C3.3054 9.62329 2.99983 9.31772 2.62292 9.31772H0.682482C0.30557 9.31772 0 9.62329 0 10.0002C0 10.3771 0.30557 10.6827 0.682482 10.6827H2.62292C2.99983 10.6827 3.3054 10.3771 3.3054 10.0002Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3174 9.31772H17.3761C16.9991 9.31772 16.6936 9.62329 16.6936 10.0002C16.6936 10.3771 16.9991 10.6827 17.3761 10.6827H19.3174C19.6944 10.6827 19.9999 10.3771 19.9999 10.0002C19.9999 9.62338 19.6944 9.31772 19.3174 9.31772Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30127 5.26612C4.43449 5.39934 4.60921 5.46595 4.78383 5.46595C4.95846 5.46595 5.13317 5.39934 5.26639 5.26612C5.53292 4.99958 5.53292 4.56744 5.26639 4.30091L3.89451 2.92902C3.62798 2.66249 3.19583 2.66249 2.92939 2.92902C2.66286 3.19556 2.66286 3.6277 2.92939 3.89415L4.30127 5.26612Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6989 14.7335C15.4324 14.467 15.0002 14.4669 14.7337 14.7334C14.467 15 14.467 15.4321 14.7336 15.6985L16.1053 17.0704C16.2386 17.2037 16.4132 17.2703 16.5879 17.2703C16.7626 17.2703 16.9373 17.2037 17.0705 17.0705C17.3371 16.804 17.3371 16.3718 17.0706 16.1054L15.6989 14.7335Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99955 4.68802C7.07061 4.68802 4.68774 7.07106 4.68774 10.0002C4.68774 12.9292 7.07061 15.3122 9.99955 15.3122C12.9288 15.3122 15.3118 12.9292 15.3118 10.0002C15.3118 7.07106 12.9287 4.68802 9.99955 4.68802ZM9.99955 13.9472C7.82325 13.9472 6.05271 12.1766 6.05271 10.0002C6.05271 7.8237 7.82325 6.05298 9.99955 6.05298C12.1761 6.05298 13.9468 7.8237 13.9468 10.0002C13.9468 12.1766 12.1761 13.9472 9.99955 13.9472Z",
    fill: "#00BCE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_1852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeIc);
export default __webpack_public_path__ + "static/media/light-mode-ic.55b39451ded12af9a4fffdc0c48ad36e.svg";
export { ForwardRef as ReactComponent };